import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Form, Formik, FormikProps } from "formik";
import { FormInput, FormSelector } from "../FormElements/index";
import { Button } from "../Elements";
import { TbDots } from "react-icons/tb";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { useDispatch } from "react-redux";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { statusOptions } from "../../../constants/options/statusOptions";
import FormObserver from "../FormElements/FormObserver";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import { userType } from "../../../constants/options/userType";
import { FilterProps } from "../../../common/types/FilterProps";
import { ThunkDispatch } from "redux-thunk";
import { getAllUsers } from "../../../store/slices/userListSlice";
import { UserListType } from "../../../common/types/UserTypes";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import { buttonTexts } from "../../../constants/texts/buttonTexts";

const initialValues: UserListType = {
  userName: "",
  userCode: "",
  email: "",
  phone: "",
  userType: 0,
  status: 0,
};

const Filters = React.forwardRef<HTMLDivElement, FilterProps>(({ isOpen, setFiltersIsOpen }, ref) => {
  // useRef's
  const formRef = useRef<FormikProps<typeof initialValues>>(null);

  // setState's
  const [formValues, setFormValues] = useState(initialValues);

  // useDispatch
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();


  useEffect(() => {
  }, [isOpen]);

  useLayoutEffect(() => { }, []);

  useEffect(() => { }, []);

  const onSubmit = async (values: any) => {
    const paramaters: any = {
      userCode: values.userCode,
      userName: values.userName,
      email: values.email,
      phone: values.phone,
      userTypeId: values.userType,
      status: values.status
    }
    dispatch(getAllUsers(paramaters));
    setFiltersIsOpen(false);
  };

  const clearFilters = () => {
    dispatch(updateIsResetForm(true));
    setTimeout(() => {
      dispatch(updateIsResetForm(false));
    }, 1000);
    formRef.current?.resetForm();
    submitForm();
  };

  const submitForm = () => {
    formRef.current?.submitForm();
  };

  const onUpdate = (value: any) => {
    setFormValues(Object.assign(formValues, value));
    submitForm();
  };

  const fields = [
    {
      key: "userName",
      label: "Kullanıcı Adı",
      type: "text",
    },
    {
      key: "userCode",
      label: "Kulanıcı Adı",
      type: "text",
    },
    {
      key: "email",
      label: "Email",
      type: "text",
    },
    {
      key: "phone",
      label: "Telefon",
      type: "text",
    },
    {
      key: "userType",
      label: "Kullanıcı Tipi",
      type: "select",
      options: userType,
    },
    {
      key: "status",
      label: "Durum",
      type: "select",
      options: statusOptions,
    },
  ];

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        values,
      }) => (
        <Form>
          <FormObserver
            watch={(val: any) => {
              setFormValues(val);
            }}
          />
          <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
            <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3">
              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormInput
                    label="Kullanıcı Adı"
                    name="userName"
                    type="text"
                    rightIcon={isLogoAppProject() && (
                      <TbDots
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    )}
                  />
                </div>
                <div className="mt-2">
                  <FormInput
                    label="Kullanıcı Kodu"
                    name="userCode"
                    type="text"
                    rightIcon={isLogoAppProject() && (
                      <TbDots
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    )}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormSelector
                    label="Kullanıcı Durumu"
                    name="status"
                    options={statusOptions}
                    placeholder="Kullanıcı durumu seç"
                    value={getSelectedValueFromId(values.status, statusOptions)}
                  />
                </div>
                <div className="mt-2">
                  <FormSelector
                    options={userType}
                    name="userType"
                    placeholder="Kullanıcı seç"
                    label="Kullanıcı Tipi"
                    isSearchable={false}
                    isClearable={true}
                    value={getSelectedValueFromId(values.userType, userType)}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormInput
                    label="Email"
                    name="email"
                    type="text"
                    rightIcon={isLogoAppProject() && (
                      <TbDots
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer"
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2 mr-0">
              <Button
                type="button"
                color="gray"
                hover="gray"
                size="xs"
                className="mr-3"
                callback={clearFilters}
              >
                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                <span className='ml-3'>{buttonTexts.filterClear}</span>
              </Button>
              <Button type="submit" color="primary" hover="primary" size="xs">
                <img src="/icons/prepare-white.svg" alt="prepare" />
                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
              </Button>
            </div>
          </div>
          <div className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""}`}>
            <FormFiltersShortList
              formValues={{ ...values }}
              fields={fields}
              initialValues={initialValues}
              callback={(val: any) => onUpdate(val)}
              clearFilter={() => {
                clearFilters();
                submitForm();
              }}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
});

export default Filters;
